/* app/js/src/components/graphics/edit/fields/scale-position.component.scss */
.cursor-pointer {
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
.advanceOption {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
}
.advanceOption input,
.advanceOption label {
  cursor: pointer;
}
.checkbox-label-settings {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
  text-transform: uppercase;
  margin-left: 3px;
}
.container {
  height: 83px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.container div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: flex-end;
}
.container div:first-of-type {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.container div span {
  margin-right: 15px;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
.container .scale-field {
  align-items: center;
}
.container .advanced-settings {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center !important;
}
.container .offset-scale-wrapper {
  width: 211px;
  height: 83px;
  display: flex;
  flex-direction: column;
  flex: 0 !important;
}
.container .offset,
.container .scale {
  flex: 0 !important;
  margin-top: 13px;
}
.container .offset-text,
.container .scale-text {
  margin: 0 !important;
  font-size: 12px !important;
  margin-right: 6px !important;
}
.container .scale-text {
  margin-right: 12px !important;
}
.container .scale-input-warpper,
.container .offset-input-warpper {
  flex: 0 !important;
  margin-right: 6px !important;
  align-items: center;
  position: relative;
}
.container icn-graphics-scale {
  width: 114px;
}
.container evrideo-graphics-layers {
  margin-left: 1vw;
}
.scale-and-layer {
  flex-basis: 300px;
}
/*# sourceMappingURL=scale-position.component.css.map */
